export default {
      id: "forme_fond-usage",
      viewBox: "0 0 680 670",
      url: "../dist/images/" + "sprite.svg#forme_fond-usage",
      toString: function () {
        return this.url;
      }
    }